var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-alert", {
        attrs: {
          title: "Email Sent",
          type: "primary",
          description: "Forgotten password email successfully sent",
          "show-icon": "",
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-action" },
        [
          _c(
            "el-button",
            { attrs: { type: "text" }, on: { click: _vm.cancelLogIn } },
            [_vm._v("Back to login")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }